var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vuetable-pagination',{ref:"pagination",attrs:{"css":_vm.css},on:{"vuetable-pagination:change-page":_vm.onChangePage}})
}
var staticRenderFns = []

export { render, staticRenderFns }